var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.014 9.512V2H22.26c-2.307 0-2.782 1.973-2.732 2.96.253 2.175-.227 6.525-4.173 6.525-3.946 0-4.932-2.732-4.932-4.097V2H2v28h8.423v-5.16c0-1.366.53-4.173 4.932-4.173 4.401 0 4.022 4.628 4.174 6.98.12 1.882 1.314 2.302 2.047 2.353h7.437v-7.436c0-1.76-2.2-1.998-3.49-1.897-1.62-.152-5.237-1.336-5.237-4.857 0-4.4 4.705-4.325 6.678-4.325 1.578 0 2.023-1.315 2.049-1.973z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKin);
export default __webpack_public_path__ + "static/media/KIN.696ca2289180b7d7809fd929d501782e.svg";
export { ForwardRef as ReactComponent };